import { PayloadSchemaField } from '@/services/data-sources/get-collection-info';

export type Cardinality = 'single' | 'multi';

/**
 * Determines which exposed attributes should render as array (multi-value)
 * inputs in the edit-file-fields modal.
 *
 * Precedence (first match wins):
 *   1. Collection-level cardinality === 'multi' → array input
 *   2. Collection-level cardinality === 'single' → scalar input, even if the
 *      sampled Qdrant point holds an array (the collection-level setting
 *      overrides sample-based inference)
 *   3. No explicit cardinality and sampled payload is an array → array input
 *   4. Default → scalar input
 */
export const resolveArrayFields = (
  exposedAttributes: string[],
  samplePayload: Record<string, unknown> | null | undefined,
  cardinality: Record<string, Cardinality> | null | undefined,
): Set<string> => {
  const set = new Set<string>();
  exposedAttributes.forEach((field) => {
    const card = cardinality?.[field];
    if (card === 'multi') {
      set.add(field);
      return;
    }
    if (card === 'single') {
      return;
    }
    if (samplePayload && Array.isArray(samplePayload[field])) {
      set.add(field);
    }
  });
  return set;
};

export type { PayloadSchemaField };
